import { getDocument, useDocument } from "hooks/firestore/core/useDocument"
import { WithRef } from "hooks/firestore/FirestoreDocument"
import { getSettingsRef } from "hooks/firestore/getRefs"
import { useShopId } from "hooks/localstate/context/useShopId"
import Settings from "types/firestore/settings"

// ts-prune-ignore-next
export function useSettings(): WithRef<Settings> | undefined
export function useSettings(shopId: string): WithRef<Settings> | undefined
export function useSettings(shopId?: string) {
  // TypeScript function overloads should prevent conditional calling of the hook
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const realShopId = shopId || useShopId()
  const { document } = useDocument(getSettingsRef(realShopId))
  return document
}

// ts-prune-ignore-next
export async function getSettings(shopId: string) {
  return await getDocument(getSettingsRef(shopId))
}
